interface IServiceWorkerNavigateMessage {
  type: 'navigate'
  link: string
}

const isNavigateMessage = (data: unknown): data is IServiceWorkerNavigateMessage =>
  !!data &&
  typeof data === 'object' &&
  (data as { type?: unknown }).type === 'navigate' &&
  typeof (data as { link?: unknown }).link === 'string'

/** Push links can be absolute (`mainUrl` + path); only a same-origin one can route in-app. */
export const toInAppPath = (link: string, origin: string): string | null => {
  try {
    const url = new URL(link, origin)
    return url.origin === origin ? `${url.pathname}${url.search}${url.hash}` : null
  } catch {
    return null
  }
}

/**
 * A notification tap asks this page to route instead of the worker reloading it — see
 * `focusAtlas` in public/service-worker.js.
 */
export const registerServiceWorkerNavigation = (navigate: (path: string) => unknown): void => {
  if (!('serviceWorker' in navigator)) {
    return
  }
  navigator.serviceWorker.addEventListener('message', (event: MessageEvent) => {
    if (!isNavigateMessage(event.data)) {
      return
    }
    const path = toInAppPath(event.data.link, window.location.origin)
    if (path) {
      void navigate(path)
    } else {
      window.location.assign(event.data.link)
    }
  })
  // addEventListener (unlike onmessage) leaves the queue closed until DOMContentLoaded.
  navigator.serviceWorker.startMessages()
}
